import axiosInstance from "@/api/axiosInstance";
import { endpoints } from "@/api/endpoints";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useSnackbar } from "notistack";


interface IFream{
  
}

export const useGetdashboardlist = (data: any) => {
    return useQuery(
      ["getalldashboardlist", data?.per_page, data?.page, data?.keyword, data?.days_filter, data?.loc_filter],
      async () => {
        return axiosInstance
          .post(`${endpoints.dashboard.getdashboardList}`, data)
          .then(({ data }) => {
            return data;
          });
      }
    );
  };



// Download CSV File
  export const useDownloadCsv = () => {

    return useMutation(
      async () => {
        return axiosInstance
          .get(endpoints.dashboard.downloadLog)
          .then(({ data }) => {
            return data;
          });
      },
      {
        
      }
    );
  };
  